module.exports = __webpack_public_path__ + "img/confluent.8c47bcd7.png";